import { render, staticRenderFns } from "./catalog-image.vue?vue&type=template&id=7a83729c&scoped=true&"
import script from "./catalog-image.vue?vue&type=script&lang=js&"
export * from "./catalog-image.vue?vue&type=script&lang=js&"
import style0 from "./catalog-image.vue?vue&type=style&index=0&id=7a83729c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83729c",
  null
  
)

export default component.exports